import { Component } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { PatronDetails } from '../../providers/patron/patron';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoHoldPickupPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-hold-pickup-popover',
  templateUrl: 'co-hold-pickup-popover.html'
})
export class CoHoldPickupPopoverComponent {

  text: string;
  locationList: Array<any>;
  patron: PatronDetails;
  chosenLocation: any = false;
  constructor(private navParams : NavParams, public viewCtrl: ViewController, private toast : ToastAlertsProvider, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.locationList = this.navParams.data.locations;
    this.patron = this.navParams.data.patron;
    if (this.patron) this.chosenLocation = this.patron.homeBranchId;
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  logLocation() {
    console.log(this.chosenLocation);
  }

  close(ifInfo){
    if (ifInfo){
      if (this.chosenLocation){
        const locationDetails = this.locationList.find( l => l.code === this.chosenLocation );
        this.viewCtrl.dismiss({location: locationDetails}).catch(err=>{});
      } else {
        this.toast.triggerToast('Please choose a pickup location','');
      }
    } else {
      this.viewCtrl.dismiss().catch(err=>{});
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-hold-pickup-popover/co-hold-pickup-popover.ts